import React from 'react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {connect} from 'react-redux';
import {Container} from 'semantic-ui-react';
import {isFemaUser} from 'common/utils';
import {Alert} from 'componentLibrary';

const nonFemaError =
  'You are not a member of this Organization. Please request access from an Authorized Organization Representative (AOR) in order to view this page';
const femaError =
  'You are not a member of this Program. Please request access from Program Admin/Assistance Officer in order to view this page';
export function UnauthorizedPage(props) {
  return (
    <Main>
      <Container>
        <Alert
          header="Not Authorized"
          content={props.isFemaUser ? femaError : nonFemaError}
          type="error"
          dismissable={false}
        />
      </Container>
    </Main>
  );
}

export function mapStateToProps(state) {
  return {
    isFemaUser: isFemaUser(state.auth.permissions),
  };
}
export default connect(mapStateToProps)(UnauthorizedPage);
